import React from 'react';
import { Ruler, ShieldCheck, Settings, Wrench } from 'lucide-react';
export function Quality() {
  const features = [{
    title: 'Custom Fit',
    copy: 'Every panel is measured and fabricated for your opening instead of relying on a one-size-fits-most shower door.',
    icon: Ruler
  }, {
    title: 'Tempered Safety Glass',
    copy: 'Shower glass is built from durable tempered glass designed for strength, safety and long-term use.',
    icon: ShieldCheck
  }, {
    title: 'Better Hardware Details',
    copy: 'Hinges, clips, handles, towel bars and brackets should look good now and hold up under everyday bathroom use.',
    icon: Settings
  }, {
    title: 'Clean Installation',
    copy: 'Professional installation helps avoid poor fit, excess caulk, uneven gaps and other issues that make a shower look unfinished.',
    icon: Wrench
  }];
  return <section className="py-20 bg-gray-50" data-id="element-1651">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-1652">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1653">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6 tracking-tight" data-id="element-1654">
            Quality Glass, Quality Hardware & Professional Installation
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1655">
            A great-looking glass shower enclosure depends on three things: the
            right glass, the right hardware and the right installation. Kosin's
            Glass focuses on custom measurements, premium tempered glass,
            quality hardware, clean details and professional installation so
            your shower looks finished and functions properly.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-1656">
          {features.map((feature, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-card border border-gray-100 scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1657">
              <div className="w-12 h-12 bg-glass rounded-xl flex items-center justify-center mb-6 text-primary" data-id="element-1658">
                <feature.icon className="w-6 h-6" data-id="element-1659" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-1660">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1661">{feature.copy}</p>
            </div>)}
        </div>
        <div className="max-w-3xl mx-auto mb-8 anim-on-scroll" data-id="element-1662">
          <div className="bg-white border-l-4 border-primary rounded-xl p-5 shadow-sm" data-id="element-1663">
            <p className="text-navy text-sm md:text-base leading-relaxed" data-id="element-1664">
              <span className="font-semibold" data-id="element-1665">
                Why local homeowners choose Kosin's Glass:
              </span>{' '}
              custom shower glass depends on precise measurement, quality
              hardware and clean installation. We bring all three to every
              project across Southeast Michigan.
            </p>
          </div>
        </div>
        <div className="text-center anim-on-scroll" data-id="element-1666">
          <a href="#quote-form" className="inline-flex items-center justify-center bg-primary hover:bg-primary-hover text-white font-semibold py-4 px-8 rounded-xl transition-colors" data-id="element-1667">
            Get a Professional Shower Door Quote
          </a>
        </div>
      </div>
    </section>;
}